import React from 'react';
import { useTranslation } from 'react-i18next';
import Close from '@mui/icons-material/Close';
import { MerchantTitle } from 'app/MerchantTitle';
import { MuiAppBar } from 'lib/appbar/MuiAppBar';
import { SignUpForm } from 'components/user/SignUpForm';

export const SignUpPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <MerchantTitle title={t('ONBOARDING_SIGN_UP')} />
            <MuiAppBar title={t('ONBOARDING_SIGN_UP')} disabledMenu icon={Close} />
            <SignUpForm />
        </>
    );
};
